import e from "react";
import { Link as i } from "@mui/material";
import { L as n } from "./chunk.BPo6egul.js";
const m = (t) => /* @__PURE__ */ e.createElement(
  i,
  {
    id: t.id,
    variant: "body100",
    href: t.href,
    component: t.to ? n : "a",
    to: t.to
  },
  t.linkText
);
export {
  m as L
};
